import { Material } from "../api/MaterialApi";
import { CUBIC_METERS_IN_UNIT } from "../engine/Calculations";

export const calculateUnitPriceBasingOnKilogramPrice = (material: Material) => {
  const kilogramPrice = material.kilogramPrice;
  return kilogramPrice === undefined
    ? null
    : kilogramPrice * material.density * CUBIC_METERS_IN_UNIT;
};